import { Component, inject, signal } from "@angular/core";
import { ConfirmationService, PrimeTemplate } from "primeng/api";
import { Router, ActivatedRoute, RouterLink } from "@angular/router";
import { AbstractListController } from "src/app/common/abstract-list.component";
import {
  PARAM_BRANDS_PATH,
  PARAM_COMPANY_PATH,
} from "src/app/constants/constants";
import { Brand } from "src/app/models/brand";
import { BrandService } from "src/app/services/brands.service";
import { Company } from "src/app/models/company";
import { CompanyService } from "src/app/services/company.service";
import { Bind } from "primeng/bind";
import { Drawer } from "primeng/drawer";

import { FormsModule } from "@angular/forms";
import { InputText } from "primeng/inputtext";
import { Select } from "primeng/select";
import { DatePicker } from "primeng/datepicker";
import { ButtonDirective } from "primeng/button";
import { TableModule } from "primeng/table";
import { NgxPaginationModule } from "ngx-pagination";
import { ConfirmDialog } from "primeng/confirmdialog";
import { TranslatePipe } from "@ngx-translate/core";

import { DynamicFiltersComponent } from "../../../components/dynamic-filters/dynamic-filters.component";
import { TPipe } from "../../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: "app-manage-company",
    templateUrl: "./manage-company.component.html",
    imports: [TPipe, DynamicFiltersComponent, Bind, Drawer, PrimeTemplate, FormsModule, InputText, Select, DatePicker, ButtonDirective, RouterLink, TableModule, NgxPaginationModule, ConfirmDialog, TranslatePipe]
})
export class ManageCompanyComponent extends AbstractListController<
  Company,
  any
> {
  protected companyService: CompanyService;
  protected confirmationService: ConfirmationService;

  title = "Aziende";
  readonly cols = signal<any[]>(undefined);
  readonly columnOptions = signal<any[]>(undefined);
  readonly selectedColumns = signal<any[]>(undefined);

  constructor() {
    const companyService = inject(CompanyService);
    const confirmationService = inject(ConfirmationService);
    const router = inject(Router);
    const route = inject(ActivatedRoute);

    super(
      companyService,
      confirmationService,
      router,
      route,
      PARAM_COMPANY_PATH,
    );
    this.companyService = companyService;
    this.confirmationService = confirmationService;

    this.cols.set([
      { field: "is_active", header: "Attivo", index: 1 },
      { field: "name", header: "Nome", index: 1 },
      { field: "description", header: "Descrizione", index: 2 },
    ]);

    this.colsFilter.set([
      {
        field: "name",
        header: "Nome",
        type: "string",
      },
    ]);
  }
}
